import { Link } from 'react-router-dom';
import { ArrowRight, Fingerprint, Globe, Workflow, Search, Rocket } from 'lucide-react';
import { PageShell, ServiceHero, CTAFinal, SERVICES } from '../components/services/Shared';
import { Reveal } from '../components/Reveal';
import { useLang } from '../i18n';

const ICONS = { branding: Fingerprint, digitalizacion: Globe, automatizacion: Workflow, 'seo-sem': Search, 'growth-partner': Rocket };

export default function ServicesHome() {
    const { t } = useLang();
    return (
        <PageShell titleKey="sp_meta_t" descKey="sp_meta_d" path="/servicios" waKey="wa_general">
            <ServiceHero h1Key="sp_home_h1" introKey="sp_home_intro" testid="servicios-home-hero" />

            <section className="py-20 lg:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="servicios-home-grid">
                        {SERVICES.map((s, i) => {
                            const Icon = ICONS[s.id];
                            const big = s.id === 'growth-partner';
                            return (
                                <Reveal key={s.id} delay={(i % 3) * 0.08} className={big ? 'md:col-span-2 lg:col-span-2' : ''}>
                                    <Link
                                        to={s.path}
                                        className={`group flex flex-col h-full rounded-[1.4rem] border border-ink/10 bg-white p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-crimson/40 hover:shadow-[0_30px_60px_-30px_rgba(27,42,74,0.4)] ${big ? 'lg:flex-row items-start lg:items-center gap-8' : ''}`}
                                        data-testid={`servicios-card-${s.id}`}
                                    >
                                        <div className="flex items-start justify-between flex-1">
                                            <div>
                                                <div className="w-14 h-14 rounded-2xl bg-pastelblue flex items-center justify-center text-ink group-hover:bg-crimson group-hover:text-pastelcream transition-colors">
                                                    <Icon size={26} strokeWidth={1.6} />
                                                </div>
                                                <h2 className="font-display text-2xl font-semibold text-ink mt-6">{t(`sp_name_${s.id}`)}</h2>
                                                <p className="mt-3 text-[15px] text-ink/70 leading-relaxed max-w-md">{t(`sp_${s.id}_short`)}</p>
                                                <span className="inline-flex items-center gap-2 mt-6 text-[12px] font-bold uppercase tracking-[0.14em] text-crimson">
                                                    {t('sp_descubrir')}
                                                    <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                                                </span>
                                            </div>
                                            <span className="font-ink text-sm text-ink/25 tracking-widest">
                                                {String(i + 1).padStart(2, '0')}
                                            </span>
                                        </div>
                                    </Link>
                                </Reveal>
                            );
                        })}
                    </div>
                </div>
            </section>

            <CTAFinal text={t('sp_home_cta')} secondary={t('sp_home_cta_sub')} message={t('wa_general')} testid="servicios-home-cta" />
            <div className="pb-6" />
        </PageShell>
    );
}
